var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "logreg",
    class: {
      showContent: _vm.showContent
    }
  }, [_c('div', {
    staticClass: "return",
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShowLogin,
      expression: "isShowLogin"
    }],
    staticClass: "login"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.wayType === '',
      expression: "wayType === ''"
    }]
  }, [_c('div', {
    staticClass: "head"
  }), _vm._v(" "), _c('p', {
    staticClass: "guide"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.typeTip'))))]), _vm._v(" "), _c('select-way', {
    attrs: {
      "wayType": _vm.wayType
    },
    on: {
      "selectWay": _vm.selectWayHandle
    }
  })], 1), _vm._v(" "), _vm.wayType === 'm-email' ? _c('email-way', {
    ref: "emailWay",
    attrs: {
      "wayType": _vm.wayType
    },
    on: {
      "showForget": _vm.showForgetHandle,
      "success": _vm.success,
      "fail": _vm.fail
    }
  }) : _vm._e(), _vm._v(" "), _vm.wayType === 'm-phone' ? _c('phone-way', {
    ref: "phoneWay",
    attrs: {
      "wayType": _vm.wayType
    },
    on: {
      "showForget": _vm.showForgetHandle,
      "success": _vm.success,
      "fail": _vm.fail
    }
  }) : _vm._e(), _vm._v(" "), _vm.wayType === '' ? _c('div', {
    staticClass: "td-wrap"
  }, [_c('third-way', {
    attrs: {
      "clientId": _vm.clientId,
      "thirdHost": _vm.thirdHost,
      "oldThirdHost": _vm.oldThirdHost,
      "wayType": _vm.wayType
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "notice"
  }, [_c('i18n', {
    attrs: {
      "path": _vm.$loginLangPrefix('userSign.termstip'),
      "tag": "p"
    }
  }, [_c('a', {
    attrs: {
      "place": "term",
      "target": "_blank",
      "href": "/protocol/terms.html"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.term'))))]), _vm._v(" "), _c('a', {
    attrs: {
      "place": "privacy",
      "target": "_blank",
      "href": "/protocol/privacy.html"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.privacy'))))])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), !_vm.isShowLogin ? _c('div', {
    staticClass: "forget"
  }, [_vm.forgetState === 'm-email' ? _c('email-forget', {
    attrs: {
      "loginName": _vm.loginName,
      "wayType": _vm.wayType
    },
    on: {
      "selectWay": _vm.selectWayHandle,
      "success": _vm.success
    }
  }) : _vm._e(), _vm._v(" "), _vm.forgetState === 'm-phone' ? _c('phone-forget', {
    attrs: {
      "loginName": _vm.loginName,
      "itc": _vm.itc,
      "country": _vm.country,
      "wayType": _vm.wayType
    },
    on: {
      "selectWay": _vm.selectWayHandle,
      "success": _vm.success
    }
  }) : _vm._e()], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };